// extracted by mini-css-extract-plugin
export default {"avatarImage":"Avatar_avatarImage__uxKV7","avatarFallback":"Avatar_avatarFallback__Ldvg9"};